<template>

  <div >
    <router-view :key="$route.fullPath"   style="overflow:auto"></router-view>
  </div>

</template>

<script>


export default {
  name: 'App',

  data(){
    return{
        windowH:null
    }
  },
  created() {
    window.addEventListener('resize', this.windowHeight);
    this.windowHeight();
  },
  methods:{
    windowHeight(){
        this.windowH =`${document.documentElement.clientHeight - 369}` + "px";

    }
  }
}
</script>

<style scoped>

</style>
